import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSearchHandlers = () => {
  const [searchParams] = useSearchParams();
  const [searchData, setSearchData] = useState({
    location: searchParams.get('location') || '',
    date: searchParams.get('date') || '',
    eventType: searchParams.get('eventType') || ''
  });
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  // Update searchData when URL parameters change
  useEffect(() => {
    setSearchData({
      location: searchParams.get('location') || '',
      date: searchParams.get('date') || '',
      eventType: searchParams.get('eventType') || ''
    });
  }, [searchParams]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchData.location.trim()) {
      // Navigate to search results with updated search parameters
      const newSearchParams = new URLSearchParams({
        location: searchData.location,
        date: searchData.date,
        eventType: searchData.eventType
      });
      
      window.history.pushState(null, '', `?${newSearchParams.toString()}`);
    }
  };

  const handleLocationSelect = (selectedLocation) => {
    setSearchData(prev => ({ ...prev, location: selectedLocation }));
    setShowLocationDropdown(false);
    
    // Update URL parameters without navigation
    const newSearchParams = new URLSearchParams({
      location: selectedLocation,
      date: searchData.date,
      eventType: searchData.eventType
    });
    
    // Update URL without triggering navigation
    window.history.replaceState(null, '', `?${newSearchParams.toString()}`);
  };

  return {
    searchData,
    setSearchData,
    showLocationDropdown,
    setShowLocationDropdown,
    handleSearchSubmit,
    handleLocationSelect
  };
};